import { cn } from '@/lib/utils.ts'
import { ChildrenProp } from '../../types_and_interfaces.ts'
import Label from '../Label.tsx'

const FormRowLayout = ({
  children,
  className,
}: ChildrenProp & { className?: string }) => {
  return (
    <div
      className={cn(
        'text-sm font-semibold text-gray-700 py-4 border-b w-full border-gray-200 flex items-center justify-between',
        className
      )}
    >
      {children}
    </div>
  )
}

const FormRowLabel = ({ children }: ChildrenProp) => {
  return <Label>{children}</Label>
}

const FormRowValue = ({ children }: ChildrenProp) => {
  return <div className="font-normal capitalize text-gray-700">{children}</div>
}

export { FormRowLayout, FormRowLabel, FormRowValue }
